import * as React from "react"
const Contributor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M19.208 11.083a2.708 2.708 0 1 1-5.416 0 2.708 2.708 0 1 1 5.416 0Zm-1.354 0a1.354 1.354 0 1 1-2.709 0 1.354 1.354 0 0 1 2.71 0ZM12.437 12.1a3.047 3.047 0 1 1-6.093 0 3.047 3.047 0 0 1 6.093 0Zm-1.354 0a1.692 1.692 0 1 1-3.385 0 1.692 1.692 0 1 1 3.385 0Zm-8.125 8.094c0-2.455 4.511-3.693 6.771-3.693.542 0 1.215.071 1.923.214.876-.681 2.595-1.568 4.848-1.568 2.253 0 3.972.887 4.848 1.568.708-.143 1.38-.214 1.923-.214 2.26 0 6.77 1.237 6.77 3.693v4.432H2.959v-4.432Zm1.354 0c0-.16.064-.373.347-.659.296-.298.764-.598 1.38-.867 1.239-.542 2.746-.813 3.69-.813.945 0 2.453.271 3.69.813.616.268 1.084.57 1.38.867.283.286.347.499.347.659v3.078H4.312v-3.078Zm15.269-2.985A6.997 6.997 0 0 0 16.5 16.5c-1.27 0-2.324.335-3.08.708 1.651.607 3.08 1.603 3.08 2.986 0-1.383 1.429-2.38 3.08-2.986Zm-1.38 2.326c-.283.286-.347.499-.347.659v3.078h10.833v-3.078c0-.16-.063-.373-.346-.659-.296-.298-.764-.598-1.38-.867-1.24-.542-2.746-.813-3.69-.813-.945 0-2.453.271-3.69.813-.616.268-1.084.57-1.38.867Zm5.408-4.388a3.046 3.046 0 1 0 .002-6.093 3.046 3.046 0 0 0-.002 6.093Zm0-1.354a1.692 1.692 0 1 0 0-3.386 1.695 1.695 0 0 0-1.692 1.693c0 .936.757 1.693 1.692 1.693Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Contributor